var map = {
	"./testlist/testlist.module": [
		"./src/app/atlas/testlist/testlist.module.ts",
		"common",
		"testlist.module.2"
	],
	"app/admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"app/atlas/atlas.module": [
		"./src/app/atlas/atlas.module.ts",
		"atlas.module"
	],
	"app/atlas/management/management.module": [
		"./src/app/atlas/management/management.module.ts",
		"common",
		"management.module"
	],
	"app/atlas/media/media.module": [
		"./src/app/atlas/media/media.module.ts",
		"common",
		"media.module.3"
	],
	"app/atlas/question/question.module": [
		"./src/app/atlas/question/question.module.ts",
		"common",
		"question.module.0"
	],
	"app/atlas/report/report.module": [
		"./src/app/atlas/report/report.module.ts",
		"common",
		"report.module.2"
	],
	"app/atlas/reportdownload/reportdownload.module": [
		"./src/app/atlas/reportdownload/reportdownload.module.ts",
		"common",
		"reportdownload.module.0"
	],
	"app/atlas/testPlayer/testPlayer.module": [
		"./src/app/atlas/testPlayer/testPlayer.module.ts",
		"common",
		"testPlayer.module"
	],
	"app/atlas/testedit/testEdit.module": [
		"./src/app/atlas/testedit/testEdit.module.ts",
		"common",
		"testEdit.module.0"
	],
	"app/atlas/uploadedmedias/uploadedmedias.module": [
		"./src/app/atlas/uploadedmedias/uploadedmedias.module.ts",
		"common",
		"uploadedmedias.module"
	],
	"app/contacts/contacts.module": [
		"./src/app/contacts/contacts.module.ts",
		"common",
		"contacts.module"
	],
	"app/forgetPassword/forgetPassword.module": [
		"./src/app/forgetPassword/forgetPassword.module.ts",
		"common",
		"forgetPassword.module"
	],
	"app/grammar_tool/grammar_tool.module": [
		"./src/app/grammar_tool/grammar_tool.module.ts",
		"common",
		"grammar_tool.module"
	],
	"app/grammar_tool/media/media.module": [
		"./src/app/grammar_tool/media/media.module.ts",
		"common",
		"media.module.1"
	],
	"app/grammar_tool/report/report.module": [
		"./src/app/grammar_tool/report/report.module.ts",
		"common",
		"report.module.1"
	],
	"app/grammar_tool/testPlayer/testPlayer.module": [
		"./src/app/grammar_tool/testPlayer/testPlayer.module.ts",
		"common",
		"testPlayer.module.1"
	],
	"app/grammar_tool/testedit/testEdit.module": [
		"./src/app/grammar_tool/testedit/testEdit.module.ts",
		"common",
		"testEdit.module.2"
	],
	"app/grammar_tool/testlist/testlist.module": [
		"./src/app/grammar_tool/testlist/testlist.module.ts",
		"common",
		"testlist.module.1"
	],
	"app/login/login.module": [
		"./src/app/login/login.module.ts",
		"common",
		"login.module"
	],
	"app/media/media.module": [
		"./src/app/media/media.module.ts",
		"common",
		"media.module.2"
	],
	"app/profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile.module"
	],
	"app/question/question.module": [
		"./src/app/question/question.module.ts",
		"common",
		"question.module.1"
	],
	"app/recoverypassword/revoverypassword.module": [
		"./src/app/recoverypassword/revoverypassword.module.ts",
		"common",
		"revoverypassword.module"
	],
	"app/report/report.module": [
		"./src/app/report/report.module.ts",
		"common",
		"report.module.0"
	],
	"app/streamingtool/media/media.module": [
		"./src/app/streamingtool/media/media.module.ts",
		"common",
		"media.module"
	],
	"app/streamingtool/streamingtool.module": [
		"./src/app/streamingtool/streamingtool.module.ts",
		"streamingtool.module"
	],
	"app/streamingtool/view/view.module": [
		"./src/app/streamingtool/view/view.module.ts",
		"common",
		"view.module"
	],
	"app/testPlayer/testPlayer.module": [
		"./src/app/testPlayer/testPlayer.module.ts",
		"common",
		"testPlayer.module.2"
	],
	"app/testedit/testEdit.module": [
		"./src/app/testedit/testEdit.module.ts",
		"common",
		"testEdit.module.1"
	],
	"app/testingtool/media/media.module": [
		"./src/app/testingtool/media/media.module.ts",
		"common",
		"media.module.0"
	],
	"app/testingtool/question/question.module": [
		"./src/app/testingtool/question/question.module.ts",
		"question.module",
		"common"
	],
	"app/testingtool/report/report.module": [
		"./src/app/testingtool/report/report.module.ts",
		"common",
		"report.module"
	],
	"app/testingtool/reportdownload/reportdownload.module": [
		"./src/app/testingtool/reportdownload/reportdownload.module.ts",
		"common",
		"reportdownload.module"
	],
	"app/testingtool/testPlayer/testPlayer.module": [
		"./src/app/testingtool/testPlayer/testPlayer.module.ts",
		"common",
		"testPlayer.module.0"
	],
	"app/testingtool/testedit/testEdit.module": [
		"./src/app/testingtool/testedit/testEdit.module.ts",
		"common",
		"testEdit.module"
	],
	"app/testingtool/testingtool.module": [
		"./src/app/testingtool/testingtool.module.ts",
		"testingtool.module"
	],
	"app/testingtool/testlist/testlist.module": [
		"./src/app/testingtool/testlist/testlist.module.ts",
		"common",
		"testlist.module.0"
	],
	"app/testlist/testlist.module": [
		"./src/app/testlist/testlist.module.ts",
		"common",
		"testlist.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main